import React from 'react';
import { Column, Direction } from '@scotia/canvas-react';
import { CardContext } from '../CardContext';

import styles from './ThreeColumnProductsLayout.scss';

const COLUMNSTYLE = 'column-style';

export const ThreeColumnProductsLayout = ({
  renderCol1,
  renderCol2,
  renderCol3,
  column1,
  column2,
  column3
}) => (
  <CardContext menuContext={false}>
    <Direction type="row" className={styles['row--style']}>
      <Column
        xs={12}
        sm={12}
        md={column1}
        lg={column1}
        className={styles[COLUMNSTYLE]}
      >
        {typeof renderCol1 === 'function' && renderCol1()}
      </Column>

      <Column
        xs={12}
        sm={12}
        md={column2}
        lg={column2}
        className={styles[COLUMNSTYLE]}
      >
        {typeof renderCol2 === 'function' && renderCol2()}
      </Column>
      <Column
        xs={12}
        sm={12}
        md={column3}
        lg={column3}
        className={styles[COLUMNSTYLE]}
      >
        {typeof renderCol3 === 'function' && renderCol3()}
      </Column>
    </Direction>
  </CardContext>
);
